import { Pin, X } from 'lucide-react';
import { Button } from '../components/atoms/Button';

interface Props {
  onDismiss: () => void;
}

/**
 * One-time tip shown after the first successful "Open in new window"
 * switcher action. Tells the user to pin the add-in so the task pane
 * auto-opens in every Word window.
 *
 * Dismissal is persisted in `localStorage` (origin-scoped — shared across
 * all documents for this user) so the tip never reappears once dismissed.
 */
export function PinAddInTooltip({ onDismiss }: Props): JSX.Element {
  return (
    <div className="flex items-start gap-2 px-3 py-2 bg-blue-50 border-b border-blue-200 text-[11px] text-blue-900">
      <Pin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0 leading-snug">
        <span className="font-medium">New Word window opened.</span>{' '}
        <span className="text-blue-800/90">
          Pin the add-in (pin icon at the top-right of the task pane) so it
          auto-opens in every Word window.
        </span>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-5 w-5"
        onClick={onDismiss}
        title="Dismiss"
      >
        <X className="w-3 h-3" />
      </Button>
    </div>
  );
}
